import { Fragment, Suspense, lazy } from 'react';
import { LoadingOverlay } from '@/components/common/LoadingOverlay';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalTypes,
} from '@/components/common/modal/modal';
import { useModalState } from '@/components/common/upload-panel/useModalState';

const LazyUploadPanel = lazy(() =>
  import(/* webpackChunkName: 'upload' */ './upload').then(({ UploadPanel }) => ({
    default: UploadPanel,
  }))
);

export const AsyncUploadPanel = () => {
  const [title, isActive, onClose, legalRef, uploadsRef, scrollStartIndex] = useModalState();

  return (
    <Modal
      type={ModalTypes.panel}
      open={isActive}
      title={title}
      className="upload-panel"
      onClose={onClose}
    >
      <Suspense
        fallback={
          <Fragment>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalContent>
              <LoadingOverlay />
            </ModalContent>
          </Fragment>
        }
      >
        <LazyUploadPanel
          onClose={onClose}
          legalRef={legalRef}
          uploadsRef={uploadsRef}
          scrollStartIndex={scrollStartIndex}
        />
      </Suspense>
    </Modal>
  );
};
